import fancy_serializer from './fancy_serializer'
import fnum from 'shared/number'
import type { FinancialNumber } from 'shared/number'

const types = {
	date: {
		can_serialize: (value: any): value is Date => value instanceof Date,
		serialize: (value: Date) => value.valueOf(),
		deserialize: (value: number) => new Date(value),
	},
	financial_number: {
		can_serialize: (value: any): value is FinancialNumber => typeof value?.getPrecision === `function`,
		serialize: (number: FinancialNumber) => number.toString(),
		deserialize: (number_string: string) => fnum(number_string),
	},
}

const unique_key = `F9ADBEF4-DD84-493B-A9D4-FCAA96C98C7A`

export default fancy_serializer({
	unique_key,
	types,
})
